const ASSETS = [
  // Menu (logos animés des 3 thèmes)
  '/logo-med-base.png?v=4', '/logo-med-part1.png?v=4', '/logo-med-part2.png?v=4', '/logo-med-part3.png?v=4',
  '/logo-dhikr-base.png?v=4',
  ...Array.from({ length: 9 }, (_, i) => `/logo-dhikr-part${i + 1}.png?v=4`),
  '/logo-resp-base.png?v=4', '/logo-resp-pissenlit.png?v=4',
  // Méditation
  '/med-icon-1.png?v=g13', '/med-icon-2.png?v=g13', '/med-icon-plume.png?v=g13',
  '/med-icon-4-base.png?v=g13', '/med-icon-4-leaves.png?v=g13',
  '/lp-seeds-1.png?v=g13', '/lp-seeds-2.png?v=g13', '/lp-seeds-3.png?v=g13',
  '/med-icon-6.png?v=g13', '/med-icon-6-halo.png?v=g13',
  '/med-icon-7-base.png?v=g13', '/med-icon-7-star.png?v=g13',
  '/med-icon-8.png?v=g13', '/med-icon-9.png?v=g13', '/med-icon-10.png?v=g13',
  '/med-icon-11-base.png?v=g13', '/med-icon-11-seeds.png?v=g13',
  '/med-icon-12.png?v=g13', '/med-icon-13.png?v=g13', '/med-icon-14.png?v=g13',
  '/med-icon-15.png?v=g13',
  // Respiration
  '/resp-carree-base.png?v=b6', '/resp-carree-fleur.png?v=b6',
  '/resp-wave-1.png?v=b6', '/resp-wave-2.png?v=b6', '/resp-wave-3.png?v=b6', '/resp-wave-4.png?v=b6',
  '/resp-icon-2.png?v=b6', '/resp-icon-1-base.png?v=b6', '/resp-icon-1-seeds.png?v=b6', '/resp-icon-4.png?v=b6',
  '/resp-apaisante-souffle.png?v=3', '/resp-478-vagues.png?v=1', '/resp-abdo-vasque.png?v=1', '/resp-coeur.png?v=1',
  // Dhikr
  '/lune-prophetes.png?v=2',
  '/dhikr-jalal-base.png?v=g13', '/dhikr-jalal-dots.png?v=g13', '/dhikr-ikram.png?v=g13',
];

let done = false;
export const preloadMeditationIcons = () => {
  if (done) return;
  done = true;
  ASSETS.forEach((src) => {
    const img = new Image();
    img.src = src;
  });
};
